import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LessonGroup } from '@digilize/language-school/definitions';

@Component({
  selector: 'lsc-lesson-marker',
  templateUrl: './lesson-marker.component.html',
  styleUrls: ['./lesson-marker.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LessonMarkerComponent implements OnInit {
  @Input() custom: { name: string; bgColor: string; textColor: string } = null;
  LessonGroup = LessonGroup;
  constructor() {}

  ngOnInit(): void {}
}
